import * as errors from './errors';
import * as success from './success';
import * as questions from './questions';

export default {
  ...errors,
  ...success,
  ...questions,
};
